<template>
  <main class="journal-page">
    <HeroSection />
    <JournalFilters />
    <Articles />
    <MostPopularSection />
  </main>
</template>

<script>
import HeroSection from './HeroSection/HeroSection.vue';
import JournalFilters from './JournalFilters/JournalFilters.vue';
import Articles from './Articles/Articles.vue';
import MostPopularSection from './MostPopularSection/MostPopularSection.vue';

export default {
  components: {
    HeroSection,
    JournalFilters,
    Articles,
    MostPopularSection,
  },
};
</script>

<style lang="scss" scoped>
@import './JournalPage.scss';
</style>
